import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useData } from '../context/DataContext';

export default function Header() {
  const { data } = useData();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef(null);

  // Home: fixed header turns white after scrolling past hero
  useEffect(() => {
    if (!isHome) return;
    const onScroll = () => {
      const hero = document.getElementById('homeHero');
      const header = headerRef.current;
      if (!hero || !header) return;
      const threshold = hero.offsetHeight - (header.offsetHeight + 12);
      setScrolled(window.scrollY > threshold);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [isHome]);

  // Close menu on route change or resize
  useEffect(() => { setMenuOpen(false); }, [location]);
  useEffect(() => {
    const onResize = () => setMenuOpen(false);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Close on scroll (mobile UX)
  useEffect(() => {
    if (!menuOpen) return;
    let lastY = window.scrollY;
    const onScroll = () => {
      if (Math.abs(window.scrollY - lastY) > 2) setMenuOpen(false);
      lastY = window.scrollY;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [menuOpen]);

  const site = data?.site || {};
  const nav = data?.site?.nav || [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Work', href: '/work' },
    { label: 'Resume', href: 'https://resume.io/resume-templates/simple', external: true },
  ];

  const headerClass = [
    'site-header',
    scrolled ? 'scrolled' : '',
    menuOpen ? 'is-open' : '',
  ].filter(Boolean).join(' ');

  return (
    <header className={headerClass} ref={headerRef}>
      <div className="site-header__inner">
        <div className="brand">
          <div id="brandWrap">
            <div className="brand-mark">
              <Link to="/">{site.title || 'Preeyanka\nMondal'}</Link>
            </div>
            <div className="brand-sub">{site.role || 'Copywriter'}</div>
          </div>
        </div>

        <button
          className="nav-toggle"
          type="button"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-controls="siteNav"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(o => !o)}
        >
          <i className={`fa-solid ${menuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
        </button>

        <nav id="siteNav" aria-label="Primary navigation">
          {nav.map(item =>
            item.external ? (
              <a key={item.label} href={item.href} target="_blank" rel="noopener noreferrer">
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.label}
                to={item.href}
                className={({ isActive }) => isActive ? 'active' : ''}
                end={item.href === '/'}
              >
                {item.label}
              </NavLink>
            )
          )}
        </nav>
      </div>
    </header>
  );
}
